import React, { useState, useEffect } from 'react'
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom'
import { useFormik } from "formik";
import * as Yup from "yup";
import TutorSidebar from '../../../../TutorSidebar/TutorSidebar';
import { useDispatch } from 'react-redux';
import toast from 'react-hot-toast';
import axios from 'axios';
import { Modal } from "react-bootstrap";
import HourglassLoader from '../../../../../../Common/HourglassLoader';
const host = process.env.REACT_APP_API_SERVER

const TutorObjectiveQuestions = () => {
    const [showModal, setShowModal] = useState(false);

    const navigate = useNavigate();
    const location = useLocation();
    const data = location?.state?.data

    useEffect(() => {
        if (!data) {
            navigate(-1)
        }
    }, [data])


    // State to store questionList
    const [questionList, setQuestionList] = useState([
        {
            id: 1,
            question: "",
            marks: "",
            first_option: "",
            second_option: "",
            third_option: "",
            fourth_option: "",
            correct_option: "",
        },
    ]);
    const [questionIdCounter, setQuestionIdCounter] = useState(2);

    // Formik setup with validation schema
    const validationSchema = Yup.object().shape({
        questionList: Yup.array().of(
            Yup.object().shape({
                question: Yup.string().required("Question is required"),
                marks: Yup.number()
                    .required("Marks are required")
                    .typeError("Marks must be a number")
                    .min(1, "Marks must be at least 1")
                    .max(100, "Marks must be less than or equal to 100"),
                first_option: Yup.string().required("First option is required"),
                second_option: Yup.string().required("Second option is required"),
                third_option: Yup.string().required("Third option is required"),
                fourth_option: Yup.string().required("Fourth option is required"),
                correct_option: Yup.string().required("Answer is required"),
            })
        ),
    });

    const formik = useFormik({
        initialValues: {
            assessment_id: data?.id,
            is_objective: 1,
            questionList: questionList,
        },
        validationSchema,

        onSubmit: async (values, { setSubmitting, resetForm }) => {


            try {

                if (values.questionList.length !== data?.no_of_question) {
                    toast.error(`The number of questions should be ${data?.no_of_question}.`);
                    return;
                }


                const totalMarks = values.questionList.reduce((sum, question) => sum + Number(question.marks), 0);


                if (totalMarks !== data?.total_marks) {
                    toast.error(
                        `The total marks must equal ${data?.total_marks}. Currently, it's ${totalMarks}.`
                    );
                    return;
                }

                setSubmitting(true);
                const config = {
                    headers: {

                        "x-auth-token": localStorage.getItem('tutor-token'),
                    },
                }
                const response = await axios.post(`${host}/api/tutor/create-objective-questions`, values, config);

                if (response.status === 200) {
                    setSubmitting(false);
                    toast.success("Questions Submitted Successfully");
                    resetForm();
                    localStorage.removeItem('data');
                    setShowModal(true);
                    setTimeout(() => {
                        setShowModal(false);
                        navigate("/tutor/dashboard");
                    }, 1000);

                } else {
                    setSubmitting(false);
                    toast.error(response.data.message);
                }
            } catch (error) {
                setSubmitting(false);
                console.error("Error:", error);
                toast.error('Error submitting form. Please try again.');
            }
        },
    });


    // Function to add a new question
    const addQuestion = () => {
        const newQuestion = {
            id: questionIdCounter,
            question: "",
            marks: "",
            first_option: "",
            second_option: "",
            third_option: "",
            fourth_option: "",
            correct_option: "",
        };

        setQuestionIdCounter(questionIdCounter + 1);
        const updatedQuestions = [...formik.values.questionList, newQuestion];
        setQuestionList(updatedQuestions);
        formik.setFieldValue("questionList", updatedQuestions);
    };

    // Function to delete a question
    const deleteQuestion = (id) => {
        const updatedQuestions = formik.values.questionList.filter((q) => q.id !== id);
        setQuestionList(updatedQuestions);
        formik.setFieldValue("questionList", updatedQuestions);
    };
    return (
        <div>

            <section className="after-header">
                {/* Breadcrum Start */}
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb bg-light">
                        <li className="breadcrumb-item  ps-5" aria-current="page">
                            <Link to="javascript:history.back()">
                                <i className="fa-solid fa-chevron-left text-dark" />
                            </Link>
                            &nbsp;&nbsp;Add Question
                        </li>
                    </ol>
                </nav>
                {/* Breadcrum End */}
                <div className="main-container-sec">
                    <div className="row mx-0">
                        <div className="col-lg-3">
                            <TutorSidebar />
                        </div>
                        <div className="col-lg-9">
                            <main className="px-3 py-4">
                                <form onSubmit={formik.handleSubmit} >
                                    <div className="add-new-course-sec">
                                        <h4 className="mb-4">Add Questions</h4>
                                        <div className="card bg-light">
                                            <div className="card-body">
                                                <div id="session-container">


                                                    {formik.values.questionList.map((question, index) => (
                                                        <div className="session mb-4" key={question.id}>
                                                            <div className="row mb-3">

                                                                {/* Marks Field */}
                                                                <div className="col-lg-12">
                                                                    <div className="input-group d-flex justify-content-between">
                                                                        <h6 className="mb-3">Question-{index + 1}</h6>
                                                                        <div>
                                                                            <input
                                                                                maxLength={4}
                                                                                type="text"
                                                                                className="input-card-form"
                                                                                placeholder={`Marks for question - ${index + 1}`}
                                                                                value={question.marks}
                                                                                name={`questionList.${index}.marks`} // Add this line
                                                                                onChange={(e) =>
                                                                                    formik.setFieldValue(
                                                                                        `questionList.${index}.marks`,
                                                                                        e.target.value
                                                                                    )
                                                                                }
                                                                                onBlur={formik.handleBlur}
                                                                            />
                                                                            {formik.touched.questionList?.[index]?.marks &&
                                                                                formik.errors.questionList?.[index]?.marks ? (
                                                                                <small className="text-danger">
                                                                                    {formik.errors.questionList[index].marks}
                                                                                </small>
                                                                            ) : null}

                                                                        </div>

                                                                    </div>

                                                                </div>
                                                                {/* Question Text */}
                                                                <div className="col-lg-12">
                                                                    <div className="input-group">
                                                                        <textarea
                                                                            className="input-card-form"
                                                                            placeholder="Write Question"
                                                                            name={`questionList.${index}.question`} // Add this line
                                                                            value={question.question}
                                                                            onChange={(e) =>
                                                                                formik.setFieldValue(
                                                                                    `questionList.${index}.question`,
                                                                                    e.target.value
                                                                                )
                                                                            }
                                                                            onBlur={formik.handleBlur}
                                                                        />
                                                                    </div>
                                                                    {formik.touched.questionList?.[index]?.question &&
                                                                        formik.errors.questionList?.[index]?.question ? (
                                                                        <small className="text-danger">
                                                                            {formik.errors.questionList[index].question}
                                                                        </small>
                                                                    ) : null}
                                                                </div>

                                                                {/* Options */}
                                                                {["first_option", "second_option", "third_option", "fourth_option"].map((optionKey, idx) => (
                                                                    <div className="row" key={optionKey}>
                                                                        <div className="col-lg-1 col-md-1 col-1 mt-2">
                                                                           <strong>{String.fromCharCode(65 + idx)}.</strong>
                                                                        </div>
                                                                        <div className="col-lg-6 col-md-11 col-11 ">
                                                                            <div className="input-group">
                                                                                <input
                                                                                    type="text"
                                                                                    className="input-card-form"
                                                                                    name={`questionList.${index}.${optionKey}`} // Add this line
                                                                                    placeholder={`Write Option ${String.fromCharCode(65 + idx)}`}
                                                                                    value={question[optionKey]}
                                                                                    onChange={(e) =>
                                                                                        formik.setFieldValue(
                                                                                            `questionList.${index}.${optionKey}`,
                                                                                            e.target.value
                                                                                        )
                                                                                    }
                                                                                    onBlur={formik.handleBlur}
                                                                                />
                                                                            </div>
                                                                            {formik.touched.questionList?.[index]?.[optionKey] &&
                                                                                formik.errors.questionList?.[index]?.[optionKey] ? (
                                                                                <small className="text-danger">
                                                                                    {formik.errors.questionList[index][optionKey]}
                                                                                </small>
                                                                            ) : null}
                                                                        </div>
                                                                    </div>
                                                                ))}



                                                                {/* Correct Answer Selection */}
                                                                <div className="row">
                                                                    <div className="col-lg-8">
                                                                        <div className="card">
                                                                            <div className="card-body">
                                                                                <h6 className="text-primary">Select Answer</h6>
                                                                                <div className="row">
                                                                                    {["first_option", "second_option", "third_option", "fourth_option"].map((optionKey, idx) => (
                                                                                        <div className="col-lg-2 col-md-6 col-6" key={optionKey}>
                                                                                            <span className="fw-bold">{String.fromCharCode(65 + idx)}</span>&nbsp;&nbsp;
                                                                                            <input
                                                                                                type="radio"
                                                                                                className="form-check-input"

                                                                                                name={`correct_option-${question.id}`}
                                                                                                checked={formik.values.questionList[index].correct_option === optionKey}
                                                                                                onChange={() =>
                                                                                                    formik.setFieldValue(
                                                                                                        `questionList.${index}.correct_option`,
                                                                                                        optionKey
                                                                                                    )
                                                                                                }
                                                                                                onBlur={formik.handleBlur}
                                                                                            />
                                                                                        </div>
                                                                                    ))}
                                                                                </div>
                                                                            </div>
                                                                            {formik.touched.questionList?.[index]?.correct_option &&
                                                                                formik.errors.questionList?.[index]?.correct_option ? (
                                                                                <small className="text-danger">
                                                                                    {formik.errors.questionList[index].correct_option}
                                                                                </small>
                                                                            ) : null}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                {/* Add and Delete Buttons */}
                                                                <div className="col-lg-12 plus-btn-sec d-flex justify-content-end">
                                                                    {formik.values.questionList.length > 1 && (
                                                                        <button
                                                                            type="button"
                                                                            className="btn btn-danger px-2 py-1 mt-3 mx-2"
                                                                            onClick={() => deleteQuestion(question.id)}
                                                                        >
                                                                            <i className="fa-solid fa-trash" />
                                                                        </button>
                                                                    )}
                                                                    {index === formik.values.questionList.length - 1 && data?.no_of_question > formik.values.questionList.length && (
                                                                        <button
                                                                            type="button"
                                                                            className="btn btn-primary px-2 py-1 mt-3"
                                                                            onClick={addQuestion}
                                                                        >
                                                                            <i className="fa-solid fa-plus" />
                                                                        </button>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ))}

                                                </div>
                                            </div>
                                        </div>

                                        {/* Submit Button */}
                                        <div className="row">
                                            <div className="col-lg-3">
                                                <button
                                                    type="submit"
                                                    className="btn btn-primary fw-bold w-100 mb-4 mt-2"
                                                    onClick={formik.handleSubmit}
                                                // data-bs-toggle="modal" data-bs-target="#adminModal"
                                                >
                                                    {formik.isSubmitting ? <HourglassLoader /> : 'Submit'}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </main>
                        </div>
                    </div>
                </div>
            </section>
            <>
                {/* Modal */}
                <Modal className='modal' show={showModal} onHide={() => setShowModal(false)}

                >

                    {/* <div className="modal-content text-center"> */}
                    <Modal.Body className='text-center'>
                        <img src="/assets/img/user/okay-img.png" className="img-fluid" />
                        <h4 className='text-center'>
                            We will reach you after getting approval from{" "}
                            <span className="text-primary">Admin</span>
                        </h4>
                        <Link to="/tutor/dashboard">
                            <button type="button" data-bs-dismiss="modal" className="btn btn-primary mt-4 px-4 mb-5">
                                Okay
                            </button>
                        </Link>
                    </Modal.Body>
                    {/* </div> */}

                </Modal>
            </>


        </div>
    )
}

export default TutorObjectiveQuestions